import { Router, NavigationEnd } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LocaleService } from './locale.service';
import { AuthService } from './auth.service';
import { CollectiveDataProvider } from '../_providers/collective-data-provider';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@angular/common/http";
import * as i3 from "./locale.service";
import * as i4 from "./auth.service";
import * as i5 from "../_providers/collective-data-provider";
export class TrackingService {
    constructor(router, http, localeService, auth, collectiveDataProvider) {
        this.router = router;
        this.http = http;
        this.localeService = localeService;
        this.auth = auth;
        this.collectiveDataProvider = collectiveDataProvider;
    }
    trackPageViews() {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event) => {
            this.sendEvent('page_view', event.urlAfterRedirects, {});
        });
    }
    trackCustomEvent(eventName, data = {}) {
        let url = this.router.url;
        this.sendEvent(eventName, url, data);
    }
    sendEvent(eventType, url, data) {
        // El colectivo puede tener desactivado el registro de actividad: en ese caso
        // no se llama al endpoint, que respondería sin guardar nada.
        if (!this.collectiveDataProvider.getTrackActivity()) {
            return;
        }
        const serviceUrl = `${environment.apiUrl}/${environment.apiVersion}/activity/store?l=${this.localeService.getLocale()}`;
        const payload = {
            '_event': eventType,
            '_api_key': environment.apiKey,
            '_user': this.auth.getUser() ? this.auth.getUser().username : null,
            '_route': url,
            '_data': data
        };
        this.http.post(serviceUrl, payload)
            .subscribe({
            next: () => console.log(`Event ${eventType} sent successfully`),
            error: (err) => console.error(`Error sending event: ${err}`)
        });
    }
}
TrackingService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TrackingService_Factory() { return new TrackingService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.LocaleService), i0.ɵɵinject(i4.AuthService), i0.ɵɵinject(i5.CollectiveDataProvider)); }, token: TrackingService, providedIn: "root" });
